import { forwardRef, MouseEventHandler } from "react";
import { UnstyledButton } from "@mantine/core";
import classes from "./ColorCircle.module.css";

type Props = {
  size?: number;
  onClick?: MouseEventHandler;
  color: string;
  /** The button's accessible name, the circle has no text */
  label: string;
};

/** A round button filled with the color, e.g. the track's color that opens the color picker */
export const ColorCircle = forwardRef<HTMLButtonElement, Props>(
  ({ size = 17, onClick, color, label }, ref) => (
    <UnstyledButton
      ref={ref}
      onClick={onClick}
      aria-label={label}
      className={classes.circle}
      style={{ backgroundColor: color, width: size, height: size }}
    />
  )
);

ColorCircle.displayName = "ColorCircle";
